module.exports = __webpack_public_path__ + "img/apple-cider-jam-turnovers.2afddf94.jpg";